import React , { useEffect , useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { useGlobalContext } from '../../context/GlobalContext';
import { getUserAuthAction } from '../../actions/authActions';
import { TOOL_ID } from '../../actions';

export default function SwitchPage() {

  const [ context , dispatch ] = useGlobalContext();
  const { userAuth, error } = context.auth;

  const history = useHistory();

  const getUser = useCallback(() => {
    getUserAuthAction(dispatch);
  },[dispatch]);

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      history.push('/login');
      return;
    }
    getUser();
    return () => {
      dispatch({
        type: 'ERROR_AUTH',
        payload: null,
      });
    }
    // eslint-disable-next-line 
  }, [])

  useEffect(() => {
    if (error === 401) {
      history.push('/login');
      return;
    }
    if (userAuth) {
      if (userAuth?.tools.find((t) => t.tool === TOOL_ID  && (t.role === "Admin" || t.role === "Owner" || t.role === "Member"))) {
        history.push("/dashboard");
      } else {
        history.push("/login")
      }
    }
  },[userAuth , history, error]);

  return (
    <div className="page-container">
    </div>
  )
}
